module.exports = __webpack_public_path__ + "img/BTM.3e18055e.svg";